module.exports = __webpack_public_path__ + "vue_assets/img/img_timeline_mobile.af9a02dc.webp";